import type { CSSProperties } from 'react';

import { Loader as KitLoader } from '@breezeventures/ui-kit/loader';
import cn from 'classnames';

type LoaderSize = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

export type LoaderProps = {
  size?: LoaderSize;
  color?: CSSProperties['color'];
  centered?: boolean;
  overlay?: boolean;
  semiTransparentBg?: boolean;
  className?: string;
};

const SIZE_PX: Record<LoaderSize, number> = {
  xs: 12,
  s: 16,
  m: 24,
  l: 40,
  xl: 56,
  xxl: 80,
};

export const Loader = ({
  size = 'm',
  color = '#3978CA',
  centered = true,
  overlay = true,
  semiTransparentBg = true,
  className,
}: LoaderProps) => {
  const px = SIZE_PX[size];

  const spinner = (
    <KitLoader width={px} height={px} style={{ color }} className={className} />
  );

  if (overlay) {
    return (
      <div
        className={cn(
          'absolute inset-0 z-300 flex items-center justify-center',
          semiTransparentBg ? 'bg-white/80' : 'bg-white'
        )}
      >
        {spinner}
      </div>
    );
  }

  if (centered) {
    return (
      <div className="flex w-full items-center justify-center">{spinner}</div>
    );
  }

  return spinner;
};
